module.exports = __webpack_public_path__ + "img/clinic.88d53b3c.svg";